import React from 'react';
import './Spinner.css';

/**
 * Lightweight, centered loading spinner.
 *
 * Used for sub-reloads (sort, search, pagination, folder navigation) where the
 * full skeleton would be too heavy — it swaps into the content area while the
 * surrounding chrome (sidebar, header) stays mounted.
 */
const Spinner = ({ label = 'Loading…', size = 40, className = '' }) => (
  <div className={`app-spinner ${className}`} role="status" aria-busy="true" aria-live="polite">
    <span className="app-spinner-circle" style={{ width: size, height: size }} />
    {label ? <span className="app-spinner-label">{label}</span> : null}
  </div>
);

export default Spinner;
